<template lang="pug">
    .popup-container(v-if="isHidden")
        .popup-wrapper
            a(href="" @click.prevent="toggle").popup-close
                img(src="@/assets/images/misc/popup-close.svg")

            .conference-popup-wrapper(v-if="singleConference.center" v-closable="{ exclude: [], handler: 'onClose' }")
                h4 {{ singleConference.event_name }}
                p.organizer by {{ singleConference.host }}

                .conference-info
                    .icon-info
                        img(src="@/assets/images/icons/calendar.svg")
                        p
                            span Date:
                            | {{ singleConference.start_date | formatDate }} - {{ singleConference.end_date | formatDate }}

                    .icon-info
                        img(src="@/assets/images/icons/location.svg")
                        p
                            span Location/Resource:
                            | {{ singleConference.center.hall_name }}

                    .icon-info
                        img(src="@/assets/images/icons/coins.svg")
                        p
                            span Fee:
                            | {{ currency }} {{ fee }}                             

                    .icon-info
                        img(src="@/assets/images/icons/user.svg")
                        p
                            span Seats Availability:
                            | {{ seats }}/{{ singleConference.no_of_public_participants_allowed }}                           

                .description
                    p {{ singleConference.description }}

                router-link( :to="{ name: 'conference', params: { 'slug': singleConference.slug, 'id': singleConference.id } }" ).button Proceed with booking                                
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ConferencePopup',
        data() {
            return {
                isHidden: false,
                currency: 'USD',
                fee: 0                
            }
        },
        props: ['singleConference', 'seats'],
        computed: mapGetters(['getCurrency', 'currencyDetails']),
        methods: {
            ...mapActions(['getRates']),
            ...Vue.filter('formatDate', function(value) {
                if(value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            }),            
            toggle: function() {
                this.isHidden = !this.isHidden
            },
            onClose: function() {
                this.isHidden = false;
            },
            updateFee() {
                this.currency = 'USD';
                this.fee = this.singleConference.fee_per_person
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        this.fee = this.singleConference.fee_per_person * this.currencyDetails.lkr;
                    });
                } else {
                   this.updateFee() 
                }
            }            
        },
        mounted() {
            this.onCurrencyUpdate();
        },
        updated() {
            this.onCurrencyUpdate();
        }
    }
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_popup-slider.sass"    
</style>


